module.exports = __webpack_public_path__ + "img/cdj.e98f0bd6.webp";